﻿import { IGOMAveragesSet } from "./GOMAveragesSet";

var BASE_URL = '/api/LiveData/GOMAverages';

export function getGOMAverages(callback: (err: any, data: IGOMAveragesSet) => any): void {
    $.ajax(BASE_URL + '', {
        cache: false,
        dataType: 'json',
        type: 'GET',
        timeout: 30000,
        success: (data: IGOMAveragesSet, text: string, jqXHR: JQueryXHR) => {
            callback(null, data);
        },
        error: (jqXHR: JQueryXHR, textStatus: string, errorThrown: string) => {
            callback(errorThrown, null);
        }
    });
}